import { environmentService, userService, postRequestHandler, getRequestHandler } from "@/utils/services";
import { compress, decompress } from 'lz-string';

let apiUrl = environmentService.apiUrlLogs;
let apiHotelsUrl = environmentService.apiUrlHotel;
let headers = { headers: userService.authHeader() };
export const logstockService = {
    searchLogstock,
    getmodules,
    getactions,
    getHotels
};

async function searchLogstock(logstockSearch) {
    return await postRequestHandler(`${apiUrl}/logstocks`, logstockSearch, headers);
}

async function getmodules() {
    return await getRequestHandler(`${apiUrl}/modules`, headers);
}

async function getactions() {
    return await getRequestHandler(`${apiUrl}/actions`, headers);
}

async function getHotels() {
    return await getRequestHandler(`${apiHotelsUrl}/hotels`, headers);
}


// WEBPACK FOOTER //
// ./src/utils/services/logstock/logstock.service.js